
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","viewBox":"0 0 20 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.64 17.985l-1.183-6.821h.4a.58.58 0 00.58-.58V6.296a.58.58 0 00-.58-.58h-5.492V1.655a.58.58 0 00-.58-.58H8.214a.58.58 0 00-.58.58v4.062H2.141a.58.58 0 00-.58.58v4.286c0 .322.259.58.58.58h.4l-1.183 6.822a.58.58 0 00.571.678H18.07a.578.578 0 00.571-.679zM3.124 7.28h6.072V2.637h1.607V7.28h6.071V9.6H3.124V7.28zM13.571 17.1v-3.482a.179.179 0 00-.179-.179h-1.071a.179.179 0 00-.179.179V17.1H7.856v-3.482a.18.18 0 00-.178-.179H6.606a.18.18 0 00-.178.179V17.1h-3.33l1.006-5.804h11.788l1.007 5.804H13.57z"}})])
          )
        }
      }
    